import { RootState } from '../../../app/store'
import { LuruRole } from '../types'

export const getCurrentUserRole = (state: RootState) =>
  state.user.data.userRoles.find((role) => role.name === LuruRole.ADMIN) ? LuruRole.ADMIN : LuruRole.REGULAR_USER
